import { render } from "./ChatApp.vue?vue&type=template&id=6b950840&scoped=true"
import script from "./ChatApp.vue?vue&type=script&lang=js"
export * from "./ChatApp.vue?vue&type=script&lang=js"

import "./ChatApp.vue?vue&type=style&index=0&id=6b950840&scoped=true&lang=css"

import exportComponent from "/home/www/omniauto/omniadmin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b950840"]])

export default __exports__